import { useSelector } from 'react-redux';

import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { BrokerConsultantBannerContainer } from '../BrokerConsultantBannerContainer';
import { MortgageRateHikeBannerContainer } from '../MortgageRateHikeBannerContainer';
import { selectIsBannerSlotClosed } from '../../selectors/mortgageRateHikeBanner';
import { CompareBannerContainer } from '../CompareBannerContainer';
import { selectRotatingBanner } from '../../selectors/selectRotatingBanner';

export const BannerContainer = () => {
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);
  const isBannerSlotClosed = useSelector(selectIsBannerSlotClosed);
  const rotatingBanner = useSelector(selectRotatingBanner);

  if (isBannerSlotClosed) {
    return null;
  }

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (rotatingBanner === 'mortgageRateHike') {
    return <MortgageRateHikeBannerContainer />;
  }

  if (rotatingBanner === 'broker') {
    return <BrokerConsultantBannerContainer />;
  }

  if (rotatingBanner === 'compare') {
    return <CompareBannerContainer />;
  }

  return null;
};
